var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-navigation-drawer",
    {
      staticClass: "elevation-1",
      attrs: {
        app: "",
        permanent: _vm.$vuetify.breakpoint.smAndUp,
        temporary: _vm.$vuetify.breakpoint.xs
      },
      model: {
        value: _vm.state,
        callback: function($$v) {
          _vm.state = $$v
        },
        expression: "state"
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "d-flex align-center px-6",
          class: {
            "mobile-drawer-logo": _vm.$vuetify.breakpoint.xs,
            "px-7": _vm.$vuetify.breakpoint.xs
          }
        },
        [
          _c("div", { staticClass: "d-flex justify-center pl-0" }, [
            _c("img", {
              staticClass: "pa-2",
              attrs: {
                height: "64px",
                src:
                  "https://d1tacsjrssg33t.cloudfront.net/images/ltt-logo-horizontal.png"
              }
            })
          ])
        ]
      ),
      _c("v-divider"),
      _c("v-list", { staticClass: "py-0" }, [
        _c(
          "div",
          [
            _vm.canViewGroup("cv")
              ? _c(
                  "v-list-group",
                  {
                    staticClass: "report-group",
                    attrs: { "prepend-icon": "mdi-folder-account" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "activator",
                          fn: function() {
                            return [
                              _c(
                                "v-list-item-content",
                                [
                                  _c("v-list-item-title", [
                                    _vm._v("Hồ sơ tuyển sinh")
                                  ])
                                ],
                                1
                              )
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      false,
                      3857755656
                    )
                  },
                  [
                    _vm.$auth.policies["view-cv"]
                      ? _c(
                          "v-list-item",
                          {
                            staticClass: "submenu-item",
                            attrs: { to: "/admin/document", link: "" }
                          },
                          [
                            _c("v-list-item-title", [
                              _vm._v("QL Hồ sơ xét tuyển")
                            ])
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.$auth.policies["view-cancel-cv"]
                      ? _c(
                          "v-list-item",
                          {
                            staticClass: "submenu-item",
                            attrs: { to: "/admin/document-cancel", link: "" }
                          },
                          [
                            _c("v-list-item-title", [_vm._v("QL Hồ sơ đã hủy")])
                          ],
                          1
                        )
                      : _vm._e(),
                    _c("v-divider"),
                    _vm.$auth.policies["view-incentive-review"]
                      ? _c(
                          "v-list-item",
                          {
                            staticClass: "submenu-item",
                            attrs: { to: "/admin/incentive-review", link: "" }
                          },
                          [
                            _c("v-list-item-title", [
                              _vm._v("QL Xét duyệt ưu đãi")
                            ])
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.$auth.policies["view-incentive-references"]
                      ? _c(
                          "v-list-item",
                          {
                            staticClass: "submenu-item",
                            attrs: {
                              to: "/admin/incentive-references",
                              link: ""
                            }
                          },
                          [
                            _c("v-list-item-title", [
                              _vm._v("QL Thông tin ưu đãi")
                            ])
                          ],
                          1
                        )
                      : _vm._e(),
                    _c("v-divider"),
                    _vm.$auth.policies["view-document-template"]
                      ? _c(
                          "v-list-item",
                          {
                            staticClass: "submenu-item",
                            attrs: { to: "/admin/document-template", link: "" }
                          },
                          [
                            _c("v-list-item-title", [
                              _vm._v("CH Thông tin trên hồ sơ")
                            ])
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.$auth.policies["view-pdf-template"]
                      ? _c(
                          "v-list-item",
                          {
                            staticClass: "submenu-item",
                            attrs: { to: "/admin/pdf-template", link: "" }
                          },
                          [
                            _c("v-list-item-title", [
                              _vm._v("CH Biểu mẫu xác nhận")
                            ])
                          ],
                          1
                        )
                      : _vm._e(),
                    _c("v-divider"),
                    _vm.$auth.policies["view-step-display-setting"]
                      ? _c(
                          "v-list-item",
                          {
                            staticClass: "submenu-item",
                            attrs: {
                              to: "/admin/display-setting-step",
                              link: ""
                            }
                          },
                          [
                            _c("v-list-item-title", [
                              _vm._v("CH Bước khai hồ sơ")
                            ])
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.$auth.policies["view-admission-config"]
                      ? _c(
                          "v-list-item",
                          {
                            staticClass: "submenu-item",
                            attrs: {
                              to: "/admin/direct-admission-product",
                              link: ""
                            }
                          },
                          [
                            _c("v-list-item-title", [
                              _vm._v("CH Hệ tuyển thẳng")
                            ])
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e(),
            _vm.canViewGroup("exam")
              ? _c(
                  "v-list-group",
                  {
                    staticClass: "report-group",
                    attrs: { "prepend-icon": "mdi-school" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "activator",
                          fn: function() {
                            return [
                              _c(
                                "v-list-item-content",
                                [_c("v-list-item-title", [_vm._v("KS ĐGNL")])],
                                1
                              )
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      false,
                      2695676901
                    )
                  },
                  [
                    _vm.$auth.policies["manage-exam"]
                      ? _c(
                          "v-list-item",
                          {
                            staticClass: "submenu-item",
                            attrs: { to: "/admin/exams", link: "" }
                          },
                          [_c("v-list-item-title", [_vm._v("QL Kỳ KSDGNL")])],
                          1
                        )
                      : _vm._e(),
                    _vm.$auth.policies["manage-exam-registration-rounds"]
                      ? _c(
                          "v-list-item",
                          {
                            staticClass: "submenu-item",
                            attrs: {
                              to: "/admin/exam-registration-rounds",
                              link: ""
                            }
                          },
                          [_c("v-list-item-title", [_vm._v("QL Đợt đăng ký")])],
                          1
                        )
                      : _vm._e(),
                    _vm.$auth.policies["manage-exam-students"]
                      ? _c(
                          "v-list-item",
                          {
                            staticClass: "submenu-item",
                            attrs: { to: "/admin/students", link: "" }
                          },
                          [
                            _c("v-list-item-title", [
                              _vm._v("QL Hồ sơ đăng ký")
                            ])
                          ],
                          1
                        )
                      : _vm._e(),
                    false &&
                    _vm.$auth.policies["approve-direct-admissions-grade1"]
                      ? _c(
                          "v-list-item",
                          {
                            staticClass: "submenu-item",
                            attrs: {
                              to: "/admin/direct-admissions-grade1",
                              link: ""
                            }
                          },
                          [
                            _c("v-list-item-title", [
                              _vm._v("Duyệt miễn thi khối 1")
                            ])
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.$auth.policies["approve-direct-admissions-grade6"]
                      ? _c(
                          "v-list-item",
                          {
                            staticClass: "submenu-item",
                            attrs: {
                              to: "/admin/direct-admissions-grade6",
                              link: ""
                            }
                          },
                          [
                            _c("v-list-item-title", [
                              _vm._v("Duyệt miễn thi khối 6")
                            ])
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.$auth.policies["approve-direct-admissions-grade10"]
                      ? _c(
                          "v-list-item",
                          {
                            staticClass: "submenu-item",
                            attrs: {
                              to: "/admin/direct-admissions-grade10",
                              link: ""
                            }
                          },
                          [
                            _c("v-list-item-title", [
                              _vm._v("Duyệt miễn thi khối 10")
                            ])
                          ],
                          1
                        )
                      : _vm._e(),
                    _c("v-divider"),
                    _vm.$auth.policies["manage-exam-codes"]
                      ? _c(
                          "v-list-item",
                          {
                            staticClass: "submenu-item",
                            attrs: { to: "/admin/code", link: "" }
                          },
                          [
                            _c("v-list-item-title", [
                              _vm._v("QL Số túi & mã phách")
                            ])
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.$auth.policies["manage-exam-absences"]
                      ? _c(
                          "v-list-item",
                          {
                            staticClass: "submenu-item",
                            attrs: { to: "/admin/absent", link: "" }
                          },
                          [
                            _c("v-list-item-title", [
                              _vm._v("QL Số Biên bản KS")
                            ])
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.$auth.policies["input-exam-marks"]
                      ? _c(
                          "v-list-item",
                          {
                            staticClass: "submenu-item",
                            attrs: { to: "/admin/markInput", link: "" }
                          },
                          [_c("v-list-item-title", [_vm._v("QL Nhập điểm")])],
                          1
                        )
                      : _vm._e(),
                    _vm.$auth.policies["view-exam-marks"]
                      ? _c(
                          "v-list-item",
                          {
                            staticClass: "submenu-item",
                            attrs: { to: "/admin/markView", link: "" }
                          },
                          [
                            _c("v-list-item-title", [
                              _vm._v("QL Điểm (sau khớp phách)")
                            ])
                          ],
                          1
                        )
                      : _vm._e(),
                    _c("v-divider"),
                    _vm.$auth.policies["manage-student-reviews"]
                      ? _c(
                          "v-list-item",
                          {
                            staticClass: "submenu-item",
                            attrs: { to: "/admin/student-review", link: "" }
                          },
                          [_c("v-list-item-title", [_vm._v("QL Phúc khảo")])],
                          1
                        )
                      : _vm._e(),
                    _c("v-divider"),
                    _vm.$auth.policies["view-result-1"]
                      ? _c(
                          "v-list-item",
                          {
                            staticClass: "submenu-item",
                            attrs: { to: "/admin/grade1-result", link: "" }
                          },
                          [
                            _c("v-list-item-title", [
                              _vm._v("QL Kết quả KSĐGNL 1")
                            ])
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.$auth.policies["view-result-6"]
                      ? _c(
                          "v-list-item",
                          {
                            staticClass: "submenu-item",
                            attrs: { to: "/admin/grade6-result", link: "" }
                          },
                          [
                            _c("v-list-item-title", [
                              _vm._v("QL Kết quả KSĐGNL 6")
                            ])
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.$auth.policies["view-result-10"]
                      ? _c(
                          "v-list-item",
                          {
                            staticClass: "submenu-item",
                            attrs: { to: "/admin/grade10-result", link: "" }
                          },
                          [
                            _c("v-list-item-title", [
                              _vm._v("QL Kết quả KSĐGNL 10")
                            ])
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.$auth.policies["view-exam-statistics"]
                      ? _c(
                          "v-list-item",
                          {
                            staticClass: "submenu-item",
                            attrs: { to: "/admin/statistics", link: "" }
                          },
                          [_c("v-list-item-title", [_vm._v(" QL Báo cáo")])],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e(),
            _vm.canViewGroup("admission")
              ? _c(
                  "v-list-group",
                  {
                    staticClass: "report-group",
                    attrs: { "prepend-icon": "mdi-file-check-outline" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "activator",
                          fn: function() {
                            return [
                              _c(
                                "v-list-item-content",
                                [
                                  _c("v-list-item-title", [
                                    _vm._v("Kết quả tuyển sinh")
                                  ])
                                ],
                                1
                              )
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      false,
                      2095868326
                    )
                  },
                  [
                    _vm.$auth.policies["view-admission-list"]
                      ? _c(
                          "v-list-item",
                          {
                            staticClass: "submenu-item",
                            attrs: { to: "/admin/admission-list", link: "" }
                          },
                          [
                            _c("v-list-item-title", [
                              _vm._v("QL Hồ sơ trúng tuyển")
                            ])
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.$auth.policies["view-direct-admission-review:grade-1"]
                      ? _c(
                          "v-list-item",
                          {
                            staticClass: "submenu-item",
                            attrs: { to: "/admin/preschool-review", link: "" }
                          },
                          [
                            _c("v-list-item-title", [
                              _vm._v("QL Xét duyệt tuyển thẳng")
                            ])
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.$auth.policies["view-admission-review"]
                      ? _c(
                          "v-list-item",
                          {
                            staticClass: "submenu-item",
                            attrs: { to: "/admin/admission-review", link: "" }
                          },
                          [
                            _c("v-list-item-title", [
                              _vm._v("QL Xét duyệt thủ công")
                            ])
                          ],
                          1
                        )
                      : _vm._e(),
                    _c("v-divider"),
                    _vm.$auth.policies["view-admission-config"]
                      ? _c(
                          "v-list-item",
                          {
                            staticClass: "submenu-item",
                            attrs: { to: "/admin/admission-method", link: "" }
                          },
                          [
                            _c("v-list-item-title", [
                              _vm._v("CH Phương thức TS")
                            ])
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.$auth.policies["view-admission-config"]
                      ? _c(
                          "v-list-item",
                          {
                            staticClass: "submenu-item",
                            attrs: { to: "/admin/admission-formula", link: "" }
                          },
                          [
                            _c("v-list-item-title", [_vm._v("CH Công thức TS")])
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.$auth.policies["view-admission-config"]
                      ? _c(
                          "v-list-item",
                          {
                            staticClass: "submenu-item",
                            attrs: { to: "/admin/admission-plan", link: "" }
                          },
                          [
                            _c("v-list-item-title", [
                              _vm._v("CH Điều kiện trúng tuyển")
                            ])
                          ],
                          1
                        )
                      : _vm._e(),
                    _c("v-divider"),
                    _vm.$auth.policies["view-result-display-setting"]
                      ? _c(
                          "v-list-item",
                          {
                            staticClass: "submenu-item",
                            attrs: {
                              to: "/admin/display-setting-result-exam",
                              link: ""
                            }
                          },
                          [
                            _c("v-list-item-title", [_vm._v("CH Ẩn / hiện KQ")])
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e(),
            _vm.canViewGroup("enroll")
              ? _c(
                  "v-list-group",
                  {
                    staticClass: "report-group",
                    attrs: { "prepend-icon": "mdi-file-document-edit-outline" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "activator",
                          fn: function() {
                            return [
                              _c(
                                "v-list-item-content",
                                [
                                  _c("v-list-item-title", [
                                    _vm._v("Quản lý nhập học")
                                  ])
                                ],
                                1
                              )
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      false,
                      1535741485
                    )
                  },
                  [
                    _vm.$auth.policies["view-online-enrollment"]
                      ? _c(
                          "v-list-item",
                          {
                            staticClass: "submenu-item",
                            attrs: { to: "/admin/online-enrollment", link: "" }
                          },
                          [
                            _c("v-list-item-title", [
                              _vm._v("QL Hồ sơ nhập học")
                            ])
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.$auth.policies["view-update-expectation"]
                      ? _c(
                          "v-list-item",
                          {
                            staticClass: "submenu-item",
                            attrs: { to: "/admin/update-expectation", link: "" }
                          },
                          [
                            _c("v-list-item-title", [
                              _vm._v("QL Chuyển đổi hệ ĐT")
                            ])
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.$auth.policies["view-submit-document"]
                      ? _c(
                          "v-list-item",
                          {
                            staticClass: "submenu-item",
                            attrs: { to: "/admin/submit-document", link: "" }
                          },
                          [
                            _c("v-list-item-title", [
                              _vm._v("QL Nhận hồ sơ gốc")
                            ])
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.$auth.policies["view-registration-form-1"] ||
                    _vm.$auth.policies["view-registration-form-6"] ||
                    _vm.$auth.policies["view-registration-form-10"] ||
                    _vm.$auth.policies["view-cv"]
                      ? _c(
                          "v-list-item",
                          {
                            staticClass: "submenu-item",
                            attrs: { to: "/admin/enroll-forms", link: "" }
                          },
                          [
                            _c("v-list-item-title", [_vm._v("QL Đơn nhập học")])
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.$auth.policies["manage-primary-class-assignment"] ||
                    _vm.$auth.policies["view-registration-form-6"] ||
                    _vm.$auth.policies["view-registration-form-10"] ||
                    _vm.$auth.policies["view-cv"]
                      ? _c(
                          "v-list-item",
                          {
                            staticClass: "submenu-item",
                            attrs: {
                              to: "/admin/grade1-class-assignment",
                              link: ""
                            }
                          },
                          [_c("v-list-item-title", [_vm._v("QL Xếp lớp")])],
                          1
                        )
                      : _vm._e(),
                    _vm.$auth.policies["view-cancel-enroll-cv"]
                      ? _c(
                          "v-list-item",
                          {
                            staticClass: "submenu-item",
                            attrs: {
                              to: "/admin/document-enroll-cancel",
                              link: ""
                            }
                          },
                          [
                            _c("v-list-item-title", [
                              _vm._v("QL Đơn hủy nhập học")
                            ])
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.$auth.policies["view-enroll-capacity"]
                      ? _c(
                          "v-list-item",
                          {
                            staticClass: "submenu-item",
                            attrs: { to: "/admin/enroll-capacity", link: "" }
                          },
                          [
                            _c("v-list-item-title", [
                              _vm._v("CH Chỉ tiêu tuyển sinh")
                            ])
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.$auth.policies["view-enrollment-window"]
                      ? _c(
                          "v-list-item",
                          {
                            staticClass: "submenu-item",
                            attrs: { to: "/admin/enrollment-window", link: "" }
                          },
                          [
                            _c("v-list-item-title", [
                              _vm._v("QL Khóa / mở nhập học")
                            ])
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e(),
            _vm.canViewGroup("crm")
              ? _c(
                  "v-list-group",
                  {
                    staticClass: "report-group",
                    attrs: { "prepend-icon": "mdi-briefcase" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "activator",
                          fn: function() {
                            return [
                              _c(
                                "v-list-item-content",
                                [
                                  _c("v-list-item-title", [
                                    _vm._v("CRM – Chuyển đổi Hồ sơ")
                                  ])
                                ],
                                1
                              )
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      false,
                      3122969385
                    )
                  },
                  [
                    _vm.$auth.policies["view-lead"]
                      ? _c(
                          "v-list-item",
                          {
                            staticClass: "submenu-item",
                            attrs: { to: "/admin/lead", link: "" }
                          },
                          [
                            _c("v-list-item-title", [
                              _vm._v("QL Hồ sơ tiềm năng")
                            ])
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.$auth.policies["view-report-crm"]
                      ? _c(
                          "v-list-item",
                          {
                            staticClass: "submenu-item",
                            attrs: { to: "/admin/report", link: "" }
                          },
                          [_c("v-list-item-title", [_vm._v("QL Báo cáo")])],
                          1
                        )
                      : _vm._e(),
                    _vm.$auth.policies["view-sale-user"]
                      ? _c(
                          "v-list-item",
                          {
                            staticClass: "submenu-item",
                            attrs: { to: "/admin/sale", link: "" }
                          },
                          [
                            _c("v-list-item-title", [
                              _vm._v("QL Nhân viên Sale")
                            ])
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e(),
            _vm.canViewGroup("communication")
              ? _c(
                  "v-list-group",
                  {
                    staticClass: "report-group",
                    attrs: { "prepend-icon": "mdi-bullhorn" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "activator",
                          fn: function() {
                            return [
                              _c(
                                "v-list-item-content",
                                [
                                  _c("v-list-item-title", [
                                    _vm._v("Email & SMS")
                                  ])
                                ],
                                1
                              )
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      false,
                      2267795503
                    )
                  },
                  [
                    _vm.$auth.policies["view-email"]
                      ? _c(
                          "v-list-item",
                          {
                            staticClass: "submenu-item",
                            attrs: { to: "/admin/email", link: "" }
                          },
                          [_c("v-list-item-title", [_vm._v("Gửi Email")])],
                          1
                        )
                      : _vm._e(),
                    _vm.$auth.policies["view-sms"]
                      ? _c(
                          "v-list-item",
                          {
                            staticClass: "submenu-item",
                            attrs: { to: "/admin/sms", link: "" }
                          },
                          [_c("v-list-item-title", [_vm._v("Gửi tin SMS")])],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e(),
            _vm.canViewGroup("website")
              ? _c(
                  "v-list-group",
                  {
                    staticClass: "report-group",
                    attrs: { "prepend-icon": "mdi-web" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "activator",
                          fn: function() {
                            return [
                              _c(
                                "v-list-item-content",
                                [
                                  _c("v-list-item-title", [
                                    _vm._v("Nội dung cổng tin")
                                  ])
                                ],
                                1
                              )
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      false,
                      183370978
                    )
                  },
                  [
                    _vm.$auth.policies["view-banner-setting"]
                      ? _c(
                          "v-list-item",
                          {
                            staticClass: "submenu-item",
                            attrs: { to: "/admin/setting-banner", link: "" }
                          },
                          [_c("v-list-item-title", [_vm._v("QL Banner")])],
                          1
                        )
                      : _vm._e(),
                    _vm.$auth.policies["view-board-1"]
                      ? _c(
                          "v-list-item",
                          {
                            staticClass: "submenu-item",
                            attrs: { to: "/admin/bulletin-1", link: "" }
                          },
                          [
                            _c("v-list-item-title", [
                              _vm._v("CH Thông tin tuyển sinh 1")
                            ])
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.$auth.policies["view-board-6"]
                      ? _c(
                          "v-list-item",
                          {
                            staticClass: "submenu-item",
                            attrs: { to: "/admin/bulletin-6", link: "" }
                          },
                          [
                            _c("v-list-item-title", [
                              _vm._v("CH Thông tin tuyển sinh 6")
                            ])
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.$auth.policies["view-board-10"]
                      ? _c(
                          "v-list-item",
                          {
                            staticClass: "submenu-item",
                            attrs: { to: "/admin/bulletin-10", link: "" }
                          },
                          [
                            _c("v-list-item-title", [
                              _vm._v("CH Thông tin tuyển sinh 10")
                            ])
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.$auth.policies["view-instruction-1"]
                      ? _c(
                          "v-list-item",
                          {
                            staticClass: "submenu-item",
                            attrs: { to: "/admin/instruction-1", link: "" }
                          },
                          [
                            _c("v-list-item-title", [
                              _vm._v("CH Hướng dẫn tuyển sinh 1")
                            ])
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.$auth.policies["view-instruction-6"]
                      ? _c(
                          "v-list-item",
                          {
                            staticClass: "submenu-item",
                            attrs: { to: "/admin/instruction-6", link: "" }
                          },
                          [
                            _c("v-list-item-title", [
                              _vm._v("CH Hướng dẫn tuyển sinh 6")
                            ])
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.$auth.policies["view-instruction-10"]
                      ? _c(
                          "v-list-item",
                          {
                            staticClass: "submenu-item",
                            attrs: { to: "/admin/instruction-10", link: "" }
                          },
                          [
                            _c("v-list-item-title", [
                              _vm._v("CH Hướng dẫn tuyển sinh 10")
                            ])
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.$auth.policies["view-popup-setting"] ||
                    _vm.$auth.policies["view-banner-setting"]
                      ? _c(
                          "v-list-item",
                          {
                            staticClass: "submenu-item",
                            attrs: { to: "/admin/setting-popup", link: "" }
                          },
                          [_c("v-list-item-title", [_vm._v("Ql Popup")])],
                          1
                        )
                      : _vm._e(),
                    _vm.$auth.policies["view-information"]
                      ? _c(
                          "v-list-item",
                          {
                            staticClass: "submenu-item",
                            attrs: { to: "/admin/enroll-news", link: "" }
                          },
                          [_c("v-list-item-title", [_vm._v("QL Tin tức")])],
                          1
                        )
                      : _vm._e(),
                    _vm.$auth.policies["view-survey"]
                      ? _c(
                          "v-list-item",
                          {
                            staticClass: "submenu-item",
                            attrs: { to: "/admin/survey-form", link: "" }
                          },
                          [
                            _c("v-list-item-title", [
                              _vm._v("QL Phiếu khảo sát")
                            ])
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e(),
            _vm.canViewGroup("event")
              ? _c(
                  "v-list-group",
                  {
                    staticClass: "report-group",
                    attrs: { "prepend-icon": "mdi-calendar-star" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "activator",
                          fn: function() {
                            return [
                              _c(
                                "v-list-item-content",
                                [_c("v-list-item-title", [_vm._v("Sự kiện")])],
                                1
                              )
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      false,
                      2214359521
                    )
                  },
                  [
                    _vm.$auth.policies["view-event-list"]
                      ? _c(
                          "v-list-item",
                          {
                            staticClass: "submenu-item",
                            attrs: { to: "/admin/event", link: "" }
                          },
                          [_c("v-list-item-title", [_vm._v("QL Sự kiện")])],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e(),
            _vm.canViewGroup("finance")
              ? _c(
                  "v-list-group",
                  {
                    staticClass: "report-group",
                    attrs: { "prepend-icon": "mdi-cash-multiple" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "activator",
                          fn: function() {
                            return [
                              _c(
                                "v-list-item-content",
                                [
                                  _c("v-list-item-title", [
                                    _vm._v("QL Tài chính")
                                  ])
                                ],
                                1
                              )
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      false,
                      4110943944
                    )
                  },
                  [
                    _vm.$auth.policies["view-invoice"]
                      ? _c(
                          "v-list-item",
                          {
                            staticClass: "submenu-item",
                            attrs: { to: "/admin/invoice-list", link: "" }
                          },
                          [_c("v-list-item-title", [_vm._v("QL Hoá đơn")])],
                          1
                        )
                      : _vm._e(),
                    _vm.$auth.policies["confirm-cash-payment"]
                      ? _c(
                          "v-list-item",
                          {
                            staticClass: "submenu-item",
                            attrs: { to: "/admin/cash-payment", link: "" }
                          },
                          [_c("v-list-item-title", [_vm._v("QL Giao dịch")])],
                          1
                        )
                      : _vm._e(),
                    _vm.$auth.policies["view-enroll"]
                      ? _c(
                          "v-list-item",
                          {
                            staticClass: "submenu-item",
                            attrs: { to: "/admin/application-fee", link: "" }
                          },
                          [
                            _c("v-list-item-title", [_vm._v("CH Phí mở hồ sơ")])
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.$auth.policies["view-product"]
                      ? _c(
                          "v-list-item",
                          {
                            staticClass: "submenu-item",
                            attrs: { to: "/admin/product-fees", link: "" }
                          },
                          [
                            _c("v-list-item-title", [
                              _vm._v("CH Phí hệ đào tạo")
                            ])
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e(),
            _vm.canViewGroup("report")
              ? _c(
                  "v-list-group",
                  {
                    staticClass: "report-group",
                    attrs: { "prepend-icon": "mdi-chart-box" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "activator",
                          fn: function() {
                            return [
                              _c(
                                "v-list-item-content",
                                [
                                  _c("v-list-item-title", [
                                    _vm._v("Báo cáo chung")
                                  ])
                                ],
                                1
                              )
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      false,
                      1166203550
                    )
                  },
                  [
                    _vm.$auth.policies["view-report"]
                      ? _c(
                          "v-list-item",
                          {
                            staticClass: "submenu-item",
                            attrs: { to: "/admin/dashboard", link: "" }
                          },
                          [
                            _c("v-list-item-title", [
                              _vm._v("Xem BC thường xuyên")
                            ])
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.$auth.policies["view-report-chart"]
                      ? _c(
                          "v-list-item",
                          {
                            staticClass: "submenu-item",
                            attrs: { to: "/admin/dashboard-chart", link: "" }
                          },
                          [_c("v-list-item-title", [_vm._v("Xem biểu đồ")])],
                          1
                        )
                      : _vm._e(),
                    _vm.$auth.policies["view-annual-report"]
                      ? _c(
                          "v-list-item",
                          {
                            staticClass: "submenu-item",
                            attrs: { to: "/admin/annual-report", link: "" }
                          },
                          [
                            _c("v-list-item-title", [_vm._v("Xem BC theo năm")])
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e(),
            _vm.canViewGroup("accounts")
              ? _c(
                  "v-list-group",
                  {
                    staticClass: "report-group",
                    attrs: { "prepend-icon": "mdi-cog" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "activator",
                          fn: function() {
                            return [
                              _c(
                                "v-list-item-content",
                                [
                                  _c("v-list-item-title", [
                                    _vm._v("Cài đặt hệ thống")
                                  ])
                                ],
                                1
                              )
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      false,
                      898494971
                    )
                  },
                  [
                    _vm.$auth.policies["view-account"]
                      ? _c(
                          "v-list-item",
                          {
                            staticClass: "submenu-item",
                            attrs: { to: "/admin/user", link: "" }
                          },
                          [_c("v-list-item-title", [_vm._v("QL TK PH")])],
                          1
                        )
                      : _vm._e(),
                    _vm.$auth.policies["account-settings"]
                      ? _c(
                          "v-list-item",
                          {
                            staticClass: "submenu-item",
                            attrs: { to: "/admin/users-management", link: "" }
                          },
                          [
                            _c("v-list-item-title", [
                              _vm._v("QL Người dùng / nhân sự")
                            ])
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.$auth.policies["policies-setting"]
                      ? _c(
                          "v-list-item",
                          {
                            staticClass: "submenu-item",
                            attrs: { to: "/admin/policies", link: "" }
                          },
                          [_c("v-list-item-title", [_vm._v("QL Phân quyền")])],
                          1
                        )
                      : _vm._e(),
                    _vm.$auth.policies["view-product"]
                      ? _c(
                          "v-list-item",
                          {
                            staticClass: "submenu-item",
                            attrs: { to: "/admin/product", link: "" }
                          },
                          [_c("v-list-item-title", [_vm._v("QL Hệ đào tạo")])],
                          1
                        )
                      : _vm._e(),
                    _vm.$auth.policies["view-display-setting"]
                      ? _c(
                          "v-list-item",
                          {
                            staticClass: "submenu-item",
                            attrs: { to: "/admin/display-setting", link: "" }
                          },
                          [
                            _c("v-list-item-title", [
                              _vm._v("CH Hiển thị chung")
                            ])
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }